// Enhanced template data with diverse professional UI/UX designs

export const enhancedTemplateData = {
  templatePreviews: [
    {
      id: 'template-1',
      name: 'Client Feedback',
      thumbnail: '/images/Capture.png',
      selected: true,
      layout: 'client-feedback',
      style: {
        containerBackground: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        containerRadius: '48px',
        containerShadow: '0 20px 50px rgba(0, 0, 0, 0.1)',
        highlightColor: '#f97316',
        headerText: 'Clients',
        headerAccent: 'Feedback',
        titleColor: '#1e293b',
        titleFontSize: '48px',
        titleFontWeight: 300,
        fontFamily: 'Inter, sans-serif',
        cardBackground: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
        cardRadius: '48px',
        cardPadding: '80px 32px 48px',
        patternOpacity: 0.05,
        textColor: 'rgba(255, 255, 255, 0.9)',
        subtitleColor: '#cbd5e1',
        nameColor: '#ffffff',
        nameFontSize: '32px',
        nameFontWeight: 600,
        feedbackFontSize: '18px',
        feedbackLineHeight: 1.6,
        avatarSize: '128px',
        avatarBorder: '8px solid #ffffff',
        avatarGradient: 'linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%)',
        avatarShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
        starActive: '#fb923c',
        starInactive: '#475569',
        starSize: '24px',
        blobWarm: 'rgba(254, 215, 170, 0.3)',
        blobCool: 'rgba(219, 234, 254, 0.3)'
      }
    },
    {
      id: 'template-2',
      name: 'Fresh Professional',

      thumbnail: '/images/Capture1.png',
      selected: false,
      layout: 'fresh-professional',
      style: {
        background: '#f8fafc',
        primaryColor: '#0ea5e9',
        secondaryColor: '#6366f1',
        textColor: '#334155',
        fontFamily: 'Inter, sans-serif',
        starColor: '#fbbf24',
        textFontSize: '20px'
      }
    },
    {
      id: 'template-3',
      name: 'Creative Geometric',
      thumbnail: '/images/temp2.png',
      selected: false,
      layout: 'creative-geometric',
      style: {
        background: '#111827',
        primaryColor: '#f9fafb',
        secondaryColor: '#db2777',
        textColor: '#e5e7eb',
        cardBackground: 'rgba(17, 24, 39, 0.8)',
        fontFamily: 'Inter',
        borderRadius: '0px',
        shadow: 'none',
        backdrop: 'blur(20px)',
        titleFontSize: '22px',
        subtitleFontSize: '30px',
        textFontSize: '20px',
        border: '1px solid rgba(75, 85, 99, 0.3)',
        radialBackground: `
          radial-gradient(circle at 20% 50%, rgba(219, 39, 119, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 40% 80%, rgba(16, 185, 129, 0.1) 0%, transparent 50%)
        `,
        cardGradient: `linear-gradient(135deg, 
          rgba(219, 39, 119, 0.05) 0%, 
          rgba(59, 130, 246, 0.05) 50%, 
          rgba(16, 185, 129, 0.05) 100%)`,
        quoteGradient: 'linear-gradient(135deg, #db2777 0%, #be185d 100%)',
        ratingBackground: 'rgba(59, 130, 246, 0.15)',
        ratingBorder: '2px solid rgba(59, 130, 246, 0.3)',
        ratingTextColor: '#60a5fa',
        starColor: '#fbbf24',
        textBorderGradient: 'linear-gradient(180deg, #db2777 0%, #3b82f6 50%, #10b981 100%)',
        avatarGradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        avatarBorder: '3px solid rgba(16, 185, 129, 0.3)',
        verifiedColor: '#10b981',
        nameGradient: 'linear-gradient(135deg, #f9fafb 0%, #d1d5db 100%)',
        detailsColor: '#9ca3af',
        dateBackground: 'rgba(75, 85, 99, 0.2)',
        dateBorder: '1px solid rgba(75, 85, 99, 0.3)',
        dateColor: '#6b7280',
        borderTopColor: 'rgba(75, 85, 99, 0.3)',
        shape1Gradient: 'linear-gradient(135deg, #db2777 0%, #be185d 100%)',
        shape2Gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        shape3Gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
      }
    },
    {
      id: 'template-4',
      name: 'Corporate Elite',
      thumbnail: '/images/temp3.png',
      selected: false,
      layout: 'professional',
      style: {
        background: 'linear-gradient(180deg, #2d3748 0%, #1a202c 100%)',
        primaryColor: '#fbbf24',
        secondaryColor: '#f59e0b',
        textColor: '#e2e8f0',
        cardBackground: '#374151',
        fontFamily: 'Source Sans Pro',
        borderRadius: '0px',
        shadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
        border: '1px solid #4b5563',
        titleFontSize: '22px',
        subtitleFontSize: '30px',
        textFontSize: '14px'
      }
    }
  ],
  generatedPost: {
    title: "Customer",
    subtitle: "Testimonial",
    userProfile: {
      name: "Dr. Amy Grantt",
      title: "Verified Customer",
      avatar: "https://i.pravatar.cc/150?img=5"
    },
    testimonialText: "Consectetur adipiscing elit, sed diam nonummy nibh euismod tempor incididunt ut labore et dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea com.",
    rating: 5,
    ctaText: "Experience Excellence"
  },
  sharingOptions: [
    { platform: 'gmb', label: 'Share to GMB' },
    { platform: 'email', label: 'Email' },
    { platform: 'facebook', label: 'Facebook' },
    { platform: 'whatsapp', label: 'Whats app' },
    { platform: 'instagram', label: 'Instagram' },
    { platform: 'copy_link', label: 'Copy link' }
  ]
};
